import { IGetDocumentsParams, IDocumentDownloadRequestObject } from './../../../models/document';
import { Action } from '@ngrx/store';

export enum DocumentLibraryActionTypes {
  GET_DOCUMENTS = 'GET_DOCUMENTS',
  GET_DOCUMENTS_SUCCESS = 'GET_DOCUMENTS_SUCCESS',
  GET_DOCUMENTS_ERROR = 'GET_DOCUMENTS_ERROR',
  DOWNLOAD_DOCUMENT = 'DOWNLOAD_DOCUMENT',
  WRITE_FILE_FROM_BLOB = 'WRITE_FILE_FROM_BLOB',
  DOWNLOAD_DOCUMENT_SUCCESS = 'DOWNLOAD_DOCUMENT_SUCCESS',
  DOWNLOAD_DOCUMENT_ERROR = 'DOWNLOAD_DOCUMENT_ERROR',
  RESET_DOCUMENTS = 'RESET_DOCUMENTS'
}

export class GetDocuments implements Action {
  readonly type = DocumentLibraryActionTypes.GET_DOCUMENTS;
  constructor(public payload: IGetDocumentsParams) { }
}
export class GetDocumentsSuccess implements Action {
  readonly type = DocumentLibraryActionTypes.GET_DOCUMENTS_SUCCESS;
  constructor(public payload: any) { }
}
export class GetDocumentsError implements Action {
  readonly type = DocumentLibraryActionTypes.GET_DOCUMENTS_ERROR;
  constructor(public payload: string) { }
}
export class DownloadDocument implements Action {
  readonly type = DocumentLibraryActionTypes.DOWNLOAD_DOCUMENT;
  constructor(public payload: IDocumentDownloadRequestObject) { }
}
export class WriteFileFromBlob implements Action {
  readonly type = DocumentLibraryActionTypes.WRITE_FILE_FROM_BLOB;
  constructor(public payload: any) { }
}
export class DownloadDocumentSuccess implements Action {
  readonly type = DocumentLibraryActionTypes.DOWNLOAD_DOCUMENT_SUCCESS;
  constructor(public payload: any) { }
}
export class DownloadDocumentFailure implements Action {
  readonly type = DocumentLibraryActionTypes.DOWNLOAD_DOCUMENT_ERROR;
  constructor(public payload: string) { }
}

export class ResetDocuments implements Action {
  readonly type = DocumentLibraryActionTypes.RESET_DOCUMENTS;
}

export type DocumentLibraryActions = GetDocuments | GetDocumentsSuccess | GetDocumentsError |
  DownloadDocument | WriteFileFromBlob | DownloadDocumentSuccess | DownloadDocumentFailure | ResetDocuments;

